import { z } from 'zod';

const telnyxCapabilitiesSchema = z.record(z.string(), z.boolean()).default({});

export const telnyxPhoneNumberSchema = z.object({
  id: z.string().uuid(),
  telnyx_id: z.string().min(1),
  phone_number: z.string().min(1),
  friendly_name: z.string().nullable().optional(),
  capabilities: telnyxCapabilitiesSchema,
  is_active: z.boolean(),
  last_synced_at: z.date().or(z.string().datetime()).nullable().optional(),
  created_at: z.date().or(z.string().datetime()),
  updated_at: z.date().or(z.string().datetime()),
  inbound_configuration_id: z.string().uuid().nullable().optional(),
  inbound_configuration_name: z.string().nullable().optional(),
});

export type TelnyxPhoneNumber = z.infer<typeof telnyxPhoneNumberSchema>;

export const telnyxPhoneNumberListSchema = z.array(telnyxPhoneNumberSchema);

export const telnyxNumberSyncResponseSchema = z.object({
  count: z.number().int().min(0),
  synced_at: z.date().or(z.string().datetime()),
});

export type TelnyxNumberSyncResponse = z.infer<typeof telnyxNumberSyncResponseSchema>;

export const telnyxAssignInboundNumberSchema = z.object({
  configuration_id: z.string().uuid().nullable(),
});

export type TelnyxAssignInboundNumberDto = z.infer<typeof telnyxAssignInboundNumberSchema>;
